import L from "leaflet";
import { CURSOR02_PATH } from "./world-map-utils";

export interface ShipMarkerIconOptions {
    isActive: boolean;
    /** Bearing in degrees from north (0 = north, 90 = east). */
    bearing: number;
}

/**
 * Creates a Leaflet DivIcon for the ship marker (cursor shape).
 * Active state shows a larger icon with pulse animation.
 */
export function createShipMarkerIcon({ isActive, bearing }: ShipMarkerIconOptions): L.DivIcon {
    const strokeColor = isActive ? '#2563eb' : '#84cc16';
    const fillColor = isActive ? '#2563eb' : '#84cc16';
    const svgRotation = bearing - 90;
    const cursorRotation = svgRotation + 180;

    const cursorSvg = (size: number) => `
        <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g transform="rotate(${cursorRotation} 12 12)">
                <path d="${CURSOR02_PATH}" stroke="${strokeColor}" stroke-width="2" fill="${fillColor}" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </svg>
    `;

    return isActive
        ? L.divIcon({
            html: `
                <div class="marker-selected-pulse" style="position:relative;width:56px;height:56px;">
                    <div style="position:absolute;inset:0;z-index:0;pointer-events:none;">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="28" cy="28" r="26" stroke="#94a3b8" stroke-width="1.5" fill="none" opacity="0.12">
                                <animate attributeName="opacity" values="0.12;0.35;0.12" dur="1.4s" repeatCount="indefinite"/>
                                <animate attributeName="r" values="6;26;6" dur="1.4s" repeatCount="indefinite" begin="0.47s"/>
                            </circle>
                            <circle cx="28" cy="28" r="18" stroke="#94a3b8" stroke-width="1.5" fill="none" opacity="0.25">
                                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="1.4s" repeatCount="indefinite" begin="0.15s"/>
                                <animate attributeName="r" values="4;18;4" dur="1.4s" repeatCount="indefinite" begin="0.23s"/>
                            </circle>
                            <circle cx="28" cy="28" r="10" stroke="#94a3b8" stroke-width="1.5" fill="none" opacity="0.4">
                                <animate attributeName="opacity" values="0.4;0.75;0.4" dur="1.4s" repeatCount="indefinite" begin="0.3s"/>
                                <animate attributeName="r" values="2;10;2" dur="1.4s" repeatCount="indefinite"/>
                            </circle>
                        </svg>
                    </div>
                    <div style="position:absolute;inset:0;z-index:1;display:flex;align-items:center;justify-content:center;">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g transform="translate(28 28) rotate(${cursorRotation}) translate(-12 -12) scale(1.17)">
                                <path d="${CURSOR02_PATH}" stroke="${strokeColor}" stroke-width="2" fill="${fillColor}" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>
                    </div>
                </div>
            `,
            className: "",
            iconSize: [56, 56],
            iconAnchor: [28, 28],
        })
        : L.divIcon({
            html: `
                <div>
                    ${cursorSvg(28)}
                </div>
            `,
            className: "",
            iconSize: [28, 28],
            iconAnchor: [14, 14],
        });
}
